exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AutocompletePlace {\n    position: relative;\n    height: 40px;\n    width: 100%;\n    max-width: 460px;\n    \n}\n\n.AutocompletePlace-results {\n  position: absolute;\n  background-color: white;\n  font-family: 'OpenSans';\n  padding: 0;\n  margin: 0;\n  border: 1px solid #00000011;\n  z-index: 1000;\n  width: inherit;\n}\n\n.AutocompletePlace-items {\n  list-style: none;\n  border: 1px solid #00000011;\n  cursor: pointer;\n  padding: 10px 10px;\n}\n\n.AutocompletePlace-items:hover {\n  background-color: #0000FF11;\n}\ninput.AutocompletePlace-input {\n    width: inherit;\n        min-height: 38px;\n    \n}\n", ""]);

// exports
